import * as React from 'react';
import {IImportProps} from "../../containers/ImportContainer";
import './ImportComponent.css';

import {t} from 'react-multi-lang';

interface IInputState {
    files: number,
}

class ImportComponent extends React.PureComponent<IImportProps, IInputState> {
    private readonly fileInput: React.RefObject<HTMLInputElement>;

    constructor(props: IImportProps) {
        super(props);

        this.state = {
            files: 0,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fileInput = React.createRef();
    }

    public render() {
        return (
            <>
                <div className="w_header">{t('import.import')}</div>
                <div className="w_component w_component_fill">
                    <form onSubmit={this.handleSubmit}>
                        <div className="w_component_row">
                            <h5>{t('import.instructions')}</h5>
                            <div>{t('import.description')}</div>
                            <div className="accordion mt-2 mb-2" id="supported_sources">
                                <div className="card">
                                    <div className="card-header w_pointer" id="headingOne" data-toggle="collapse"
                                         data-target="#collapseOne" aria-expanded="true"
                                         aria-controls="collapseOne">
                                        <div className="font-weight-bold" title={t('import.hover')}>
                                            {t('import.acm.title')}
                                        </div>
                                    </div>
                                    <div id="collapseOne" className="collapse" aria-labelledby="headingOne"
                                         data-parent="#supported_sources">
                                        <div className="card-body">
                                            <ol type="1" className="m-0">
                                                <li>{t('import.acm.step_1')}
                                                    <a href="https://dl.acm.org/" className="text-primary ml-1">
                                                        https://dl.acm.org/
                                                    </a>
                                                </li>
                                                <li>{t('import.acm.step_2')}</li>
                                                <li>{t('import.acm.step_3')}</li>
                                                <li>{t('import.acm.step_4')}</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header w_pointer" id="headingTwo" data-toggle="collapse"
                                         data-target="#collapseTwo"
                                         aria-expanded="false" aria-controls="collapseTwo">
                                        <div className="font-weight-bold" title={t('import.hover')}>
                                            {t('import.sciencedirect.title')}
                                        </div>
                                    </div>
                                    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo"
                                         data-parent="#supported_sources">
                                        <div className="card-body">
                                            <ol type="1" className="m-0">
                                                <li>{t('import.sciencedirect.step_1')}
                                                    <a href="https://www.sciencedirect.com/"
                                                       className="text-primary ml-1">
                                                        https://www.sciencedirect.com/
                                                    </a>
                                                </li>
                                                <li>{t('import.sciencedirect.step_2')}</li>
                                                <li>{t('import.sciencedirect.step_3')}</li>
                                                <li>{t('import.sciencedirect.step_4')}</li>
                                                <li>{t('import.sciencedirect.step_5')}</li>
                                                <li>{t('import.sciencedirect.step_6')}</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header w_pointer" id="headingThree" data-toggle="collapse"
                                         data-target="#collapseThree"
                                         aria-expanded="false" aria-controls="collapseThree">
                                        <div className="font-weight-bold" title={t('import.hover')}>
                                            {t('import.scopus.title')}
                                        </div>
                                    </div>
                                    <div id="collapseThree" className="collapse" aria-labelledby="headingThree"
                                         data-parent="#supported_sources">
                                        <div className="card-body">
                                            <ol type="1" className="m-0">
                                                <li>{t('import.scopus.step_1')}
                                                    <a href="https://www.scopus.com/"
                                                       className="text-primary ml-1">
                                                        https://www.scopus.com/
                                                    </a>
                                                </li>
                                                <li>{t('import.scopus.step_2')}</li>
                                                <li>{t('import.scopus.step_3')}</li>
                                                <li>{t('import.scopus.step_4')}</li>
                                                <li>{t('import.scopus.step_5')}</li>
                                                <li>{t('import.scopus.step_6')}</li>
                                                <li>{t('import.scopus.step_7')}</li>
                                                <li>{t('import.scopus.step_8')}</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header w_pointer" id="headingFour" data-toggle="collapse"
                                         data-target="#collapseFour"
                                         aria-expanded="false" aria-controls="collapseFour">
                                        <div className="font-weight-bold" title={t('import.hover')}>
                                            {t('import.wos.title')}
                                        </div>
                                    </div>
                                    <div id="collapseFour" className="collapse" aria-labelledby="headingFour"
                                         data-parent="#supported_sources">
                                        <div className="card-body">
                                            <ol type="1" className="m-0">
                                                <li>{t('import.wos.step_1')}
                                                    <a href="https://www.webofknowledge.com/"
                                                       className="text-primary ml-1">
                                                        https://www.webofknowledge.com/
                                                    </a>
                                                </li>
                                                <li>{t('import.wos.step_2')}</li>
                                                <li>{t('import.wos.step_3')}</li>
                                                <li>{t('import.wos.step_4')}</li>
                                                <li>{t('import.wos.step_5')}</li>
                                                <li>{t('import.wos.step_6')}</li>
                                                <li>{t('import.wos.step_7')}</li>
                                                <li>{t('import.wos.step_8')}</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header w_pointer" id="headingFive" data-toggle="collapse"
                                         data-target="#collapseFive"
                                         aria-expanded="false" aria-controls="collapseFive">
                                        <div className="font-weight-bold" title={t('import.hover')}>
                                            {t('import.ieee.title')}
                                        </div>
                                    </div>
                                    <div id="collapseFive" className="collapse" aria-labelledby="headingFive"
                                         data-parent="#supported_sources">
                                        <div className="card-body">
                                            <ol type="1" className="m-0" start={1}>
                                                <li>{t('import.ieee.step_1')}
                                                    <a href="http://ieeexplore.ieee.org/"
                                                       className="text-primary ml-1">
                                                        http://ieeexplore.ieee.org/
                                                    </a>
                                                </li>
                                                <li>{t('import.ieee.step_2')}</li>
                                                <li>{t('import.ieee.step_3')}</li>
                                                <li>{t('import.ieee.step_4')}</li>
                                                <li>{t('import.ieee.step_5')}</li>
                                                <li>{t('import.ieee.step_6')}</li>
                                                <li>{t('import.ieee.step_7')}</li>
                                                <li>{t('import.ieee.step_8')}</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 mb-2">{t('import.alternative')}</div>
                        <div className="card">
                            <div className="card-header" id="headingSix">
                                <div className="font-weight-bold">
                                    {t('import.custom.title')}
                                </div>
                            </div>
                            <div id="collapseSix" aria-labelledby="headingSix">
                                <div className="card-body">
                                    <ol type="1" className="m-0" start={1}>
                                        <li>{t('import.custom.step_1')}</li>
                                        <li>{t('import.custom.step_2')}</li>
                                        <li>{t('import.custom.step_3')}</li>
                                        <li>{t('import.custom.step_4')}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div className="w_component_row input-group mt-5">
                            <div className="custom-file">
                                <input type="file" className="custom-file-input import_source" id="import_source"
                                       ref={this.fileInput} multiple={true} accept=".bib,.json" name="import_source"
                                       onChange={this.handleInputChange}/>
                                <label className="custom-file-label" htmlFor="import_source">
                                    {this.state.files ?
                                        `${this.state.files} ${t('import.files_selected')}`
                                        :
                                        `${t('import.choose_file')}`}
                                </label>
                            </div>
                            <div className="input-group-append">
                                <button className="input-group-text" id=""
                                        title={t('import.upload_hover')}>
                                    {t('import.upload')}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </>
        );
    }

    private handleInputChange() {
        if (this.fileInput.current && this.fileInput.current.files) {
            this.setState({
                files: this.fileInput.current.files.length
            });
        } else {
            this.setState({
                files: 0
            });
        }
    }

    private handleSubmit(event: any) {
        event.preventDefault();

        if (this.fileInput.current && this.fileInput.current.files && this.fileInput.current.files.length > 0) {
            this.props.dispatchParseUploadedFiles(this.fileInput.current.files, this.props.history);
        }
    }
}

export default ImportComponent;



// WEBPACK FOOTER //
// ./src/components/ImportComponent/ImportComponent.tsx